var ACCOUNT_NUMBER_PATTERN = /(^|[^\d])(\d{4}[ \t.-]?\d{2}[ \t.-]?\d{5})(?!\d)/g;
var MOD11_WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
var PAYMENT_CONTEXT_PATTERN = /konto|kontonr|overfør|nettbank|betaling/i;
var passesMod11 = function (accountNumber) {
    var digits = accountNumber.replace(/[ \t.-]/g, '');
    var weightedSum = digits.split('').reduce(function (sum, digit, index) { return sum + Number(digit) * MOD11_WEIGHTS[index]; }, 0);
    return weightedSum % 11 === 0;
};
// eslint-disable-next-line import/prefer-default-export
export var containsLikelyNorwegianAccountNumber = function (body) {
    var hasPaymentContext = PAYMENT_CONTEXT_PATTERN.test(body);
    var pattern = new RegExp(ACCOUNT_NUMBER_PATTERN.source, 'g');
    var match = pattern.exec(body);
    while (match) {
        var candidate = match[2];
        if (passesMod11(candidate)) {
            return true;
        }
        var firstSeparator = candidate.slice(4, 5);
        var secondSeparator = candidate.slice(7, 8);
        var hasBothSeparators = /[ \t.-]/.test(firstSeparator)
            && /[ \t.-]/.test(secondSeparator);
        if (hasBothSeparators && hasPaymentContext) {
            return true;
        }
        match = pattern.exec(body);
    }
    return false;
};
